import { motion } from "framer-motion";
import { t } from "./Translator";

export default function MenuAndReserve({ children, onlyReserve, dark, onRequestDemandCard }: { children: any, onlyReserve?: boolean, dark?: boolean, onRequestDemandCard?: () => void }) {
    // Removed reserve state and related navigation logic
    // Sticky button will just call onRequestDemandCard
    return (
        <div className={`w-full ${dark ? "bg-brown-dark" : "bg-white"} relative min-h-screen z-30`}>
            <div onClick={onRequestDemandCard}>
                <motion.div
                    animate={{
                        width: 60
                    }}
                    initial={false}
                    transition={{ ease: "easeInOut" }}
                    className={`z-30 cursor-pointer hidden md:block right-0 top-0 bottom-0 h-screen fixed ${(dark) ? "bg-brown-dark border-brown-inverted text-white " : "bg-white border-brown-dark"} hover:text-brown-light border-l border-opacity-16`}>
                    <div className="whitespace-nowrap w-full h-screen flex items-center justify-center text-16" style={{ writingMode: "vertical-rl" }}>{t("Nezávazná poptávka")}</div>
                </motion.div>
            </div>
            {children}
        </div>
    )
}